"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'couponRecord',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        status: '',
        nickname: '',
        name: '',
        searchType: 'all',
        content: ''
      },
      name: '',
      nickname: '',
      props: {
        emitPath: false
      },
      categoryList: [],
      productId: 0,
      timeVal: [],
      cardLists: []
    };
  },
  filters: {
    receiveType: function receiveType(val) {
      var typeObj = {
        1: '用户领取',
        2: '商品赠送券',
        3: '平台活动使用'
      };
      return typeObj[val];
    }
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:coupon:user:page:list'])) this.getList('');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.pay_time = e ? this.timeVal.join('-') : '';
    },
    //重置
    reset: function reset() {
      this.tableFrom.page = 1;
      this.tableFrom.status = '';
      this.tableFrom.nickname = '';
      this.tableFrom.name = '';
      this.tableFrom.searchType = 'all';
      this.tableFrom.content = '';
      this.name = '';
      this.nickname = '';
      // this.timeVal = [];
      this.getList();
    },
    // 列表
    getList: function getList(num) {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.name = encodeURIComponent(this.name);
      this.tableFrom.nickname = encodeURIComponent(this.nickname);
      this.tableFrom.page = num ? num : this.tableFrom.page;
      (0, _marketing.couponUserListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.listLoading = false;
      }).catch(function (res) {
        _this.listLoading = false;
        if (res && !res.__requestMessageShown) _this.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
    }
  }
};